import Vue from "vue";
import Vuex from "vuex";

import api from "./api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentOrganization: localStorage.getItem("currentOrganization") ? JSON.parse(localStorage.getItem("currentOrganization")) : null,
    currentLeague: localStorage.getItem("currentLeague") ? JSON.parse(localStorage.getItem("currentLeague")) : null,
    currentSeason: localStorage.getItem("currentSeason") ? JSON.parse(localStorage.getItem("currentSeason")) : null,
    locale:
      localStorage.getItem("locale") && ["ja", "en"].includes(localStorage.getItem("locale"))
        ? localStorage.getItem("locale")
        : localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).locale
        : "en",
    leagues: localStorage.getItem("leagues") ? JSON.parse(localStorage.getItem("leagues")) : [],
    organizations: [],
    user: JSON.parse(localStorage.getItem("user")),
  },
  getters: {
    user: state => state.user,
    isAuthenticated: state => !!state.user,
    currentOrganization: state => state.currentOrganization,
    currentSeason: state => state.currentSeason,
    currentLeague: state => state.currentLeague,
    locale: state => (state.locale && state.locale !== "undefined" ? state.locale : "en"),
    leagueInformation: state => state.leagues,
    organizationInformation: state => state.organizations,
    leagues: state => state.leagues,
  },
  mutations: {
    setLeagueInformation(state, items) {
      if (items && items !== "undefined") {
        state.leagues = items;
        localStorage.setItem("leagues", JSON.stringify(items));
      }
    },
    setOrganizationInformation(state, items) {
      state.organizations = items;
    },
    setCurrentOrganization(state, items) {
      if (items && items != "undefined") {
        state.currentOrganization = items;
        localStorage.setItem("currentOrganization", JSON.stringify(items));
      }
    },
    setCurrentLeague(state, items) {
      if (items && items != "undefined") {
        state.currentLeague = items;
        localStorage.setItem("currentLeague", JSON.stringify(items));
      }
    },
    setCurrentSeason(state, items) {
      if (items && items != "undefined") {
        state.currentSeason = items;
        localStorage.setItem("currentSeason", JSON.stringify(items));
      }
    },
    setUser(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
      if (user && user.locale != "undefined") {
        state.locale = user.locale;
        localStorage.setItem("locale", JSON.stringify(user.locale));
      }
    },
    setLocale(state, locale) {
      if (locale && locale != "undefined") {
        state.locale = locale;
        localStorage.setItem("locale", JSON.stringify(locale));
      }
    },
    clearUser(state) {
      state.user = null;
      state.currentLeague = null;
      state.currentSeason = null;
      state.currentOrganization = null;
      state.leagues = null;
      state.organizations = null;
      state.locale = null;
      localStorage.removeItem("user");
      localStorage.removeItem("currentLeague");
      localStorage.removeItem("currentSeason");
      localStorage.removeItem("currentOrganization");
      localStorage.removeItem("leagues");
      localStorage.removeItem("organizations");
      localStorage.removeItem("locale");
    },
  },
  actions: {
    setCurrentOrganization({ commit }, organization) {
      if (organization) {
        commit("setCurrentOrganization", organization);
      }
    },
    setCurrentLeague({ commit }, league) {
      if (league) {
        commit("setCurrentLeague", league);
      }
    },
    setCurrentSeason({ commit }, season) {
      if (season) {
        commit("setCurrentSeason", season);
      }
    },
    getLeagueInformation({ commit }) {
      if (this.getters.isAuthenticated) {
        api.getLeagueInformation().then(response => {
          console.log("🏀 GLI", response.data);
          if (!response.data) {
            return;
          }
          commit("setOrganizationInformation", response.data.organizations);
          commit("setCurrentOrganization", response.data.current_organization);
          commit("setLeagueInformation", response.data.leagues);
          if (response.data.user) {
            commit("setUser", response.data.user);
            var user = response.data.user;
            window.analytics.identify(user.id, {
              name: user.first + " " + user.last,
              email: user.email,
            });
          }
          var lid = this.getters.currentLeague ? this.getters.currentLeague.id : null;
          var sid = this.getters.currentSeason ? this.getters.currentSeason.id : null;
          var found = false;
          response.data.leagues.forEach(l => {
            if (lid == l.id) {
              found = true;
              commit("setCurrentLeague", l);
            }
          });
          if (!found) {
            commit("setCurrentLeague", response.data.leagues[0]);
          }
          found = false;
          if (this.getters.currentLeague) {
            this.getters.currentLeague.seasons.forEach(s => {
              if (sid == s.id) {
                commit("setCurrentSeason", s);
                found = true;
              }
            });
            if (!found) {
              commit("setCurrentSeason", this.getters.currentLeague.seasons[0]);
            }
          }
        });
      }
    },
    signIn({ commit }, { email, password }) {
      // The Promise used for router redirect in Signin.vue
      return new Promise((resolve, reject) => {
        api
          .createSession(email, password)
          .then(response => {
            commit("setUser", response.data);
            resolve();
          })
          .catch(error => {
            // if the request fails, clear user
            commit("clearUser");
            reject(error.response.data.error);
          });
      });
    },
    signUp({ commit }, { first, last, organization, email, password, timezone, timezone_offset, locale }) {
      // The Promise used for router redirect in Signup.vue
      return new Promise((resolve, reject) => {
        api
          .createUser(first, last, organization, email, password, timezone, timezone_offset, locale)
          .then(response => {
            commit("setUser", response.data);
            resolve();
          })
          .catch(error => {
            commit("clearUser");
            reject(error.response.data.errors);
          });
      });
    },
    signOut({ commit }) {
      // The Promise used for router redirect in Header.vue
      commit("clearUser");
      return new Promise(resolve => {
        api.deleteSession().then(() => {
          resolve();
        });
      });
    },
  },
});
